import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class GoodCategory  {
    _originalTypeClassName = "zERP.BO.GoodCategory";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
GoodCategory.translate = translateService;
}
this.Entity = new Domain.BusinessEntity();
this.Children = [];
this.Id = null;
this.Name = null;
this.Path = null;
this.Code = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
Path:any;
Code:any;
Entity:any;
Children:any;
Parent:any;
static setEntity = ($this, value) => {
var oldValue = $this.Entity;
$this.Entity = value;
if (value != null) {
}
}
static setChildren = ($this, items) => {
                if (items == null) items = [];
                if ($this.Children == null) $this.Children = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Children.length > 0) {
                    Domain.GoodCategory.removeChildren($this, $this.Children[0]);
                }

                Domain.GoodCategory.addManyChildren($this, copyItems);
            }
static addManyChildren = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.GoodCategory.addChildren($this, items[i]);
                }
            }
static addChildren = ($this, item) => {
                if ($this.Children == null) $this.Children = [];
                if (item == null || $this.Children.indexOf(item) > -1) return;
                $this.Children.push(item);
if (item.Parent != $this) {
Domain.GoodCategory.setParent(item, $this);
}
}
static addRangeChildren = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.GoodCategory.addChildren($this, item));
            }
static removeChildren = ($this, item) => {
                if ($this == null || $this.Children == null || $this.Children.indexOf(item) === -1) return;
                var _index = $this.Children.indexOf(item);
                $this.Children.splice(_index, 1);
item.Parent = null;
}
static clearChildren = ($this) => { $this.Children = null; }
static setParent = ($this, value) => {
var oldValue = $this.Parent;
$this.Parent = value;
if (value != null) {
if (oldValue != null) {
Domain.GoodCategory.removeChildren(oldValue, $this);
}
Domain.GoodCategory.addChildren(value, $this);
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}